<template>
  <component :is="tag" class="chip" :href="href">
    <slot />
  </component>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
  href: {
    type: String,
    default: null
  }
})

const tag = computed(() => (props.href ? 'a' : 'span'))
</script>
<style lang="scss" scoped>
.chip {
  display: block;
  padding: 6px 12px;
  border-radius: 80px;
  background: $gray-3;
  font-size: 10px;
  line-height: 160%;
  color: #000;
}
</style>
